import { useEffect, useState } from "react";
import InputAHSF from "../../../../Components/InputAHSF";
import { useDispatch, useSelector } from "react-redux";
import {
  AddImplementationStage,
  EditImplementationStage,
  GetSpecificRowImplementationStage,
} from "../../../../Redux/Reducers/Submitter/ImplementationStages";
import ButtonAHSF from "../../../../Components/ButtonAHSF";
import $ from "jquery";
import Swal from "sweetalert2";

const ImplementationStagesAdd = (props) => {
  const dispatch = useDispatch();
  const [ImplementationStages, setImplementationStages] = useState(null);
  const [StageName, setStageName] = useState(null);
  const implementationStages = useSelector(
    (state) => state.ImplementationStageReducers.SpecificRowImplementationStage
  );

  const [ImplementationStagesValidation, setImplementationStagesValidation] =
    useState(false);
  const [StageNameValidation, setStageNameValidation] = useState(false);

  const AddImplementationStages = () => {
    if (validation()) {
      dispatch(
        AddImplementationStage({
          implementationPeriodMonths: ImplementationStages,
          applicationInformationId: localStorage.getItem(
            "ApplicationInformationId"
          ),
          stageName: StageName,
        })
      );
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تمت الأضافة بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      $(".close-btn").trigger("click");
    }
  };

  const validation = () => {
    let validationStatus = true;
    if (ImplementationStages == null) {
      setImplementationStagesValidation(true);
      validationStatus = false;
    } else {
      setImplementationStagesValidation(false);
      validationStatus = true;
    }

    if (StageName == null) {
      setStageNameValidation(true);
      validationStatus = false;
    } else {
      setStageNameValidation(false);
      validationStatus = true;
    }
    return validationStatus;
  };
  useEffect(() => {
    if (props.EditOrView) {
      dispatch(
        GetSpecificRowImplementationStage({
          implementationStagesId: props.implementationStagesId,
        })
      );
    }
  }, [props.implementationStagesId]);

  useEffect(() => {
    if (props.EditOrView) {
      setImplementationStages(implementationStages?.implementationPeriodMonths);
      setStageName(implementationStages?.stageName);
    }
  }, [implementationStages]);

  const EditImplementationStages = () => {
    if (validation()) {
      dispatch(
        EditImplementationStage({
          implementationStagesId: implementationStages.implementationStagesId,
          stageName: StageName,
          implementationPeriodMonths: ImplementationStages,
          applicationInformationId:
            implementationStages.applicationInformationId,
        })
      );
      Swal.fire({
        position: "center",
        icon: "success",
        title: "تمت التعديل بنجاح",
        showConfirmButton: false,
        timer: 1500,
        // width: "500px",
      });
      $(".close-btn").trigger("click");
    }
  };
  const HTML = (
    <>
      <InputAHSF
        fieldsName="StageName"
        show={true}
        disabled={false}
        onChange={(e) => {
          setStageName(e.target.value);
        }}
        showValidationMessage={StageNameValidation}
        validationMessage={"حقل اجباري"}
        defaultValue={props.EditOrView ? implementationStages?.stageName : ""}
      />
      <InputAHSF
        fieldsName="ImplementationPeriod"
        show={true}
        disabled={false}
        type={"number"}
        // comma={true}
        onChange={(e) => {
          setImplementationStages(e.target.value);
        }}
        showValidationMessage={ImplementationStagesValidation}
        validationMessage={"حقل اجباري"}
        defaultValue={
          props.EditOrView
            ? implementationStages?.implementationPeriodMonths
            : ""
        }
      />
      {!props.shouldDisableFields ? (
        <>
          <div className="ConainerButtonAHSF">
            <ButtonAHSF
              onClick={
                props.EditOrView
                  ? EditImplementationStages
                  : AddImplementationStages
              }
              //   onClick={AddImplementationStages}

              text={"حفظ"}
              show={true}
            />
          </div>
        </>
      ) : (
        <></>
      )}
    </>
  );
  return (
    <>
      {props.EditOrView ? (
        implementationStages?.stageName ? (
          <>{HTML}</>
        ) : (
          <></>
        )
      ) : (
        <>{HTML}</>
      )}
    </>
  );
};
export default ImplementationStagesAdd;
